import { trans } from '@spotahome/soyuz/client';
import { structureFaqs } from '@spotahome/ui-library/src/utils/faqs';

const getFaqKeys = () => [
  {
    top: 'tenant-guarantees.faqs.item-1.title',
    content: 'tenant-guarantees.faqs.item-1.content'
  },
  {
    top: 'tenant-guarantees.faqs.item-2.title',
    content: 'tenant-guarantees.faqs.item-2.content'
  },
  {
    top: 'tenant-guarantees.faqs.item-3.title',
    content: 'tenant-guarantees.faqs.item-3.content'
  },
  {
    top: 'tenant-guarantees.faqs.item-4.title',
    content: 'tenant-guarantees.faqs.item-4.content'
  },
  {
    top: 'tenant-guarantees.faqs.item-5.title',
    content: 'tenant-guarantees.faqs.item-5.content'
  },
  {
    top: 'tenant-guarantees.faqs.item-6.title',
    content: 'tenant-guarantees.faqs.item-6.content'
  },
  {
    top: 'tenant-guarantees.faqs.item-7.title',
    content: 'tenant-guarantees.faqs.item-7.content'
  },
  {
    top: 'tenant-guarantees.faqs.item-8.title',
    content: 'tenant-guarantees.faqs.item-8.content'
  },
  {
    top: 'tenant-guarantees.faqs.item-9.title',
    content: 'tenant-guarantees.faqs.item-9.content'
  }
];

export const getFaqs = () =>
  getFaqKeys()
    .map(faq => ({
      top: trans(faq.top),
      content: trans(faq.content)
    }))
    .filter(Boolean);

export const getStructuredFaqs = transFn => {
  const faqs = getFaqKeys()
    .map(faq => ({
      top: transFn(faq.top),
      content: transFn(faq.content)
    }))
    .filter(Boolean);

  return structureFaqs(faqs);
};

export default {
  getFaqs,
  getStructuredFaqs
};
